import { graphql } from "gatsby";
import React from "react";
import Layout from "../../../components/Layout";
import FiltrationResults from "../../../components/LearnFiltrationResultComponents";
import WithI18next from "../../../components/WithI18next";

const Filtration = ({ data, pageContext }) => {
  const { articleCategories, podcastCategories = {}, posts, iconFilter } = data;
  return (
    <Layout
      title="Learn | Filtration Results | Zipmex"
      description="Learn about digital asset investing with Zipmex exchange"
    >
      <FiltrationResults
        articleCategories={articleCategories}
        podcastCategories={podcastCategories}
        posts={posts.nodes}
        iconFilter={iconFilter}
        isThai={pageContext.isThai}
      />
    </Layout>
  );
};

export default WithI18next()(Filtration);

// TODO: move fragment to global
export const query = graphql`
  query (
    $wpLocale: String!
    $wpGlobalConfig: String!
    $isThai: Boolean = false
    $inCategories: [String]!
  ) {
    articleCategories: allWpCategory(
      filter: {
        slug: { regex: "/articles/" }
        language: { locale: { eq: $wpLocale } }
      }
    ) {
      ...Category
    }
    podcastCategories: allWpCategory(
      filter: { slug: { eq: "podcasts" }, language: { locale: { eq: "th" } } }
    ) @include(if: $isThai) {
      ...Category
    }
    posts: allWpPost(
      filter: {
        categories: {
          nodes: {
            elemMatch: { wpParent: { node: { slug: { in: $inCategories } } } }
          }
        }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      sort: { order: DESC, fields: date }
    ) {
      ...Post
    }

    iconFilter: file(relativePath: { eq: "images/icons/filter.svg" }) {
      publicURL
    }
  }
`;
